<template>
  <v-layout row align-center justify-space-between class="code-item">
    <v-flex class="my-2" grow>
      <div class="font-weight-bold message my-1">{{code.message}}</div>
      <div class="serial-number my-1">{{code.serial_number}}</div>
    </v-flex>
    <v-flex class="my-2" shrink>
      <v-btn flat large color="primary" @click="handleClick">Edit</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import * as transactionUtils from '@/utils/transaction'

export default {
  name: 'CodeItem',
  props: ['code'],
  methods: {
    handleClick() {
      this.$emit('edit')
    }
  }
}
</script>

<style lang="scss" scoped>

.circle{
  border-radius: 50%;
  background: #2a63d5;
}

.label{
  font-size: 11px;
}

.serial-number{
  font-size: 16px;
  font-weight: 600;
}

.message{
  font-size: 13px;
}

</style>
